import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './fetchBaseQuery';
import { VerificationRequest } from '../types';

const api = createApi({
    reducerPath: 'contactVerifyApi',
    baseQuery,
    endpoints: build => ({
        verifyContactCode: build.mutation<void, VerificationRequest>({
            query: body => ({
                url: '/auth/api/contact/verify',
                method: 'POST',
                body,
            }),
        }),
        sendContactCodeEmail: build.mutation<void, string>({
            query: email => ({
                url: '/auth/api/contact/send-code',
                method: 'POST',
                body: email,
            }),
        }),
    }),
});
export const { useVerifyContactCodeMutation, useSendContactCodeEmailMutation } = api;
export default api;
